'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/_axios@0.18.0@axios/lib/cancel/isCancel.js
// module id = 137
// module chunks = 0